import { render, staticRenderFns } from "./componentHelper.vue?vue&type=template&id=edd8b64e&scoped=true&"
import script from "./componentHelper.vue?vue&type=script&lang=js&"
export * from "./componentHelper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd8b64e",
  null
  
)

export default component.exports